<template>
  <div class="content edit-page minus-margin20">
    <CommonStep :step-list="stepList"></CommonStep>
    <el-row class="content-2-col" id="rightForm">
      <!-- <template v-if="!isShowCommonForm"> -->
      <template v-if="showCardStep === 1">
        <AdCommonOrderForm
          :isShowParent="isShowParent"
          :partnerId="projectOrder.partnerId"
          :createType="createType"
          @go-back="$emit('go-back')"
          @next="goNextStep"
        ></AdCommonOrderForm>
      </template>
      <template v-if="showCardStep === 2">
        <AdCommonForm
          ref="commonForm"
          :order="commonForm"
          :cableCheckable="cableCheckable"
          :editForm="editForm"
          :mode="mode"
          :isLockPreviousStep="isLockPreviousStep"
          @step="getStep(arguments)"
          @go-back="$emit('go-back')"
          @add-media="handleAddMedia"
        ></AdCommonForm>
      </template>
      <template v-if="showCardStep === 3">
        <!-- <AdCommonFormLock :lockObj="lockObj" :mode="mode"  @go-back="$emit('go-back')" @previous-step="handlePreviousStep" @add-media="handleAddMedia">
        </AdCommonFormLock>-->
      </template>
      <template v-if="showCardStep === 4">
        <MaterialCreativeAddForm :orderScheduleForm="orderScheduleForm" @go-back="$emit('go-back')"></MaterialCreativeAddForm>
      </template>
    </el-row>
  </div>
</template>
<script>
import CommonStep from '@/components/common/CommonStep'
import AdCommonForm from '@/components/AdCommonForm'
import MaterialCreativeAddForm from '../creative/MaterialCreativeAddForm'
import AdCommonOrderForm from '@/components/AdCommonOrderForm'
export default {
  components: {
    AdCommonForm,
    CommonStep,
    MaterialCreativeAddForm,
    AdCommonOrderForm
  },
  inject: ['projectOrder'],
  data() {
    return {
      showCardStep: 0,
      isLockPreviousStep: false, // 是否上一步返回
      loading: true,
      isMac: false,
      orderOptions: [],
      orderOptionsIndex: {},
      editForm: {}, // 编辑回显
      lockObj: {}, // 锁量数据
      isShowCommonForm: false,
      stepList: [
        {
          parent: '项目订单',
          status: this.mode === 'edit' ? '2' : '1',
          children: [
            {
              label: '订单设置',
              status: this.mode === 'edit' ? '2' : '1'
            }
          ]
        },
        {
          parent: '投放计划',
          status: this.mode === 'edit' ? '1' : '0',
          children: [
            {
              label: '基础设置',
              status: this.mode === 'edit' ? '1' : '0'
            },
            {
              label: '投放设置',
              status: '0'
            },
            {
              label: '定向',
              status: '0'
            },
            {
              label: '计划名称',
              status: '0'
            }
          ]
        },
        {
          parent: '素材创意',
          status: '0',
          children: [
            {
              label: '素材上传',
              status: '0'
            }
          ]
        }
      ],
      budgetCost: '',
      isShowParent: false,
      createType: 'oldTab',
      commonForm: {},
      orderScheduleForm: {}, // 新增素材参数
      cableCheckable: true
    }
  },
  props: ['mode', 'id', 'prevOrder', 'prevSchedule'],
  methods: {
    handleCancel() {
      const isChange = this.$consts.difference(this.form, this.oldScheduleForm)
      if (Object.keys(isChange).length === 0) {
        this.$emit('go-back')
      } else {
        this.$confirm('页面内容未保存，确定要离开吗？', '提示', {
          confirmButtonText: '离开页面',
          cancelButtonText: '留在页面',
          center: true,
          type: 'warning'
        })
          .then(() => {
            this.$emit('go-back')
          })
          .catch(() => {})
      }
    },
    // 第二步
    goNextStep(data) {
      this.commonForm = {
        orderId: data.orderId,
        orderNo: data.orderNo,
        orderName: data.orderName,
        partnerId: data.partnerId,
        sellingType: data.sellingType,
        buyType: data.buyType,
        iesSwitch: data.iesSwitch,
        contractBeginDate: new Date(data.contractBeginDate).getTime(),
        contractEndDate: new Date(data.contractEndDate).getTime()
      }
      this.getCableCheckable(data.partnerId)
      this.showCardStep = 2
      this.handleChangeStepStatus()
    },
    // 第三步，锁量确认
    getStep(data) {
      this.showCardStep = 3
      this.lockObj = {
        form: data[0],
        tableData: data[1],
        collapseDevice: data[2],
        sizeOptions: data[3],
        beforeChangeTotalTraffic: data[4],
        beforeChangeBudegtCost: data[5],
        order: data[6]
      }
    },
    // 锁量返回上一步
    handlePreviousStep(data) {
      this.editForm = data.form
      this.order = data.order
      this.showCardStep = 2
      this.isLockPreviousStep = true
    },
    // 缩量添加素材
    handleAddMedia(data) {
      this.showCardStep = 4
      this.orderScheduleForm = data
      this.handleChangeStepStatus()
    },
    // 改变左侧步骤条状态
    handleChangeStepStatus() {
      let index = this.stepList.findIndex(item => item.status === '1')
      this.stepList[index].status = '2'
      this.stepList[index].children.forEach(item => {
        item.status = '2'
      })
      this.stepList[index + 1].status = '1'
      this.stepList[index + 1].children[0].status = '1'
    },
    // 编辑回显
    getScheduleById() {
      this.$service.getScheduleById({ scheduleId: this.id }).then(data => {
        this.$service.getOrderById({ id: data.orderId }).then(order => {
          this.commonForm = {
            orderId: order.orderId,
            orderNo: order.orderNo,
            orderName: order.orderName,
            partnerId: order.partnerId,
            sellingType: order.sellingType,
            contractBeginDate: new Date(order.contractBeginDate + ' 00:00:00').getTime(),
            contractEndDate: new Date(order.contractEndDate + ' 23:59:59').getTime()
          }
          this.getCableCheckable(order.partnerId)
          this.editForm = data
          this.showCardStep = 2
        })
      })
    },
    getCableCheckable(partnerId) {
      const params = {
        cableNo: 'IQIYI',
        partnerId: partnerId
      }
      this.$service.getCabelStatus(params).then(res => {
        this.cableCheckable = res.data === 0
      })
    },
    detectOS() {
      let isMac =
        navigator.platform === 'Mac68K' ||
        navigator.platform === 'MacPPC' ||
        navigator.platform === 'Macintosh' ||
        navigator.platform === 'MacIntel'
      if (isMac) return true
    },
    onScroll() {
      let scrolled = document.getElementById('rightForm').scrollTop
      this.stepList[1].children.forEach(item => {
        item.status = '0'
      })
      if (scrolled < 459) {
        this.stepList[1].children[0].status = '1'
      } else if (scrolled >= 459 && scrolled < 786) {
        this.stepList[1].children[1].status = '1'
      } else if (scrolled >= 786 && scrolled < 1370) {
        this.stepList[1].children[2].status = '1'
      } else {
        this.stepList[1].children[3].status = '1'
      }
    },
    handleScroll(data) {
      let height = document.getElementById(data.label)
      if (height) {
        let total = height.offsetTop
        document.getElementById('rightForm').scrollTo({
          top: total,
          behavior: 'smooth'
        })
      }
    }
  },
  mounted() {
    let box = document.getElementById('rightForm')
    box.addEventListener('scroll', () => {
      this.onScroll()
    })
  },
  created() {
    this.$bus.$on('stepChange', event => {
      this.handleScroll(event)
    })
    this.isMac = this.detectOS()
    if (this.mode === 'edit') {
      this.getScheduleById()
    } else {
      this.showCardStep = 1
    }
    if (this.projectOrder.accountType === '1') {
      this.isShowParent = true
    } else {
      this.isShowParent = false
    }
  }
}
</script>
<style lang="stylus" scoped>
.content
  display flex
  flex-direction row
  height 100%
.edit-page
  overflow hidden
  height calc(100vh - 60px)
.content-2-col
  width calc(100vw - 132px)
  padding 16px
  overflow auto
.content-3-col
  width calc(100vw - 132px)
  padding 16px 0 16px 16px
  overflow auto
.demo-ruleForm
  max-width 800px
.demo-ruleForm .el-select
  display flex
>>>.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after
  content '*'
  color #f56c6c
  margin-right 4px
>>> .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before
  display none
</style>
